<template>
    <div>
      <div v-if="(!data || data.length === 0) && loading">
        <SingleChartLoader></SingleChartLoader>
      </div>
      <div v-if="(!data || data.length === 0) && !loading" class="text-center py-5">
        <h4>Chart data is not available.</h4>
      </div>
      <div v-else-if="data && data.length > 0 && yDataAvailable === true" class="chart-column liberated-gas-chart-column">
        <div class="modal-tab-div">
            <div class="tab-div">
                <p>Y Axis Scale:</p>
                <v-btn-toggle
                    v-model="isYLog"
                    class="axis-toggle setHeight"
                    mandatory
                    @update:modelValue="handleYScaleToggleChange"
                  >
                  <v-btn :value="true" class="switch-btn" outlined>Log</v-btn>
                    <v-btn :value="false" class="switch-btn" outlined>Linear</v-btn>
                  </v-btn-toggle>
            </div>
          </div>
        <ChartTitleTooltip :title="chartTitle" />
        <div v-if="isMounted" class="main-chart mr-md-2">
          <div :ref="chartId"></div>
        </div>
        <v-dialog v-model="modal" class="multi-chart-preview-div dashboard-chart-preview composition liberated-gas-chart-preview">
          <v-card class="position-relative studio-card">
            <v-card-text>
              <div class="popup-top">
                <div class="modal-tab-div">
            <div class="tab-div">
                <p>Y Axis Scale:</p>
                <v-btn-toggle
                    v-model="isModalYLog"
                    class="axis-toggle setHeight"
                    mandatory
                    @update:modelValue="handleModalYScaleToggleChange"
                  >
                  <v-btn :value="true" class="switch-btn" outlined>Log</v-btn>
                    <v-btn :value="false" class="switch-btn" outlined>Linear</v-btn>
                  </v-btn-toggle>
            </div>
          </div>
                <ChartTitleTooltip :title="chartTitle" extra-class="w-100" />
              </div>
              <div :ref="modalChartId" class="modal-chart-container"></div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
      <div v-else-if="data && data.length > 0 && yDataAvailable === false" class="text-center pt-5 pb-12">
        <h4>Chart data is not available.</h4>
      </div>
    </div>
  </template>
  
  <script>
  import Plotly from "plotly.js-dist-min";
  import SingleChartLoader from "../Loaders/SingleChartLoader.vue";
  import ChartTitleTooltip from "../DifferentialLiberation/Charts/ChartTitleTooltip.vue";
  import Expand from "../../../assets/Svg/Chart/expand-btn.svg";
  import downloadIcon from '../../../assets/Svg/Chart/csv_chart.svg';
import camIcon from '../../../assets/Svg/camIcon.svg';
import { mapGetters } from "vuex";
import { chartGridColor } from "@/utils/chartTheme";
import { downloadPlotlyHostAsPng } from "@/utils/plotlyPngDownload";
import { buildSimpleScatterLogYAxisConfig, collectPositiveYValuesFromSeries } from "@/utils/plotlyLogAxis";

const VAPOR_COMPONENT_MOLE_CSV_HEADER = "Vapor Component Mole";
const LIBERATED_GAS_Y_AXIS_TITLE = "Mole";

  export default {
    name: "LiberatedGasPressureChart", 
    components: {
      SingleChartLoader,
      ChartTitleTooltip,
    },
    props: {
      data: {
        type: Array,
        default: () => [],
      },
      loading: {
        type: Boolean,
        default: true,
      },
      toggleFraction: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
         cross: require("../../../assets/Svg/Chart/chart-cross.svg"),
        chartId: "lineChart",
        chartData: [],
        uniqueFluidComponents: [],
        modal: false,
        modalChartId: "modalLineChart",
        chartTitle: "Evolved Gas Compositions at various Pressures",
        isMounted: false,
        yDataAvailable: true,
        yAxisScale: "linear",
    isYLog: false,
    modalYAxisScale: "linear",
    isModalYLog: false,
      };
    },
    computed: {
      ...mapGetters("darkMode", ["isDarkMode"]),
    },
    watch: {
      data(newVal, oldVal) {
        if (newVal !== oldVal && newVal.length > 0) {
          this.plotChart();
        }
      },
      yAxisScale() {
      this.plotChart();
    },
    isDarkMode() {
      this.plotChart();
    }
    },
    mounted() {
      this.isMounted = true;
    },
    methods: {
      handleYScaleToggleChange() {
    if (this.yAxisScale === undefined) {
      this.yAxisScale = 'linear';
    }

      this.yAxisScale = this.isYLog ? "log" : "linear";
      this.modalYAxisScale = this.yAxisScale;
    if(this.modalYAxisScale === "log") {
      this.isModalYLog = true;
    }
    else {
this.isModalYLog = false;
    }
  },
  handleModalYScaleToggleChange() {
    if (this.modalYAxisScale === undefined) {
      this.modalYAxisScale = 'linear';
    }

      this.modalYAxisScale = this.isModalYLog ? "log" : "linear";

      this.plotModalChart()
  },
      plotChart() {
        const differentiaLiberationData = this.data;
        const vaporMoleFractionsByComponent = {};
  
        differentiaLiberationData.forEach((step) => {
          const fluidComponent = step.fluidComponentReference;
          const vaporMoleFraction = step.vaporMoleFraction;
          const stepPressure = step.stepPressure;
          if (!vaporMoleFractionsByComponent[fluidComponent]) {
            vaporMoleFractionsByComponent[fluidComponent] = [];
          }
          vaporMoleFractionsByComponent[fluidComponent].push({ pressure: stepPressure, moleFraction: vaporMoleFraction });
  
        });
  
          this.chartData = Object.entries(vaporMoleFractionsByComponent).map(([component, values]) => {
            const xData = values.map(entry => entry.pressure);
            const yData = values.map(entry => entry.moleFraction);
  
            if (yData.every(value => value === undefined) || yData.every(value => value === null) || !yData) {
              this.yDataAvailable = false;
            }
            else {
              this.yDataAvailable = true;
            }
  
            return {
              name: component,
              x: xData,
              y: yData,
            };
          });
  
  
  
        this.$nextTick(() => {
          if (this.isMounted && this.$refs[this.chartId]) {
            this.plotChartWithData();
          }
        });
      },
  
      plotChartWithData() {
        const axisType = this.yAxisScale || "linear";
        const traces = this.chartData.map((series) => ({
          x: series.x,
          y: series.y.map((value) => {
            const numericValue = Number(value);
            if (!Number.isFinite(numericValue)) {
              return null;
            }
            if (axisType === "log" && numericValue <= 0) {
              return null;
            }
            return numericValue;
          }),
          type: "scatter",
          mode: "lines+markers",
          name: series.name,
          connectgaps: false,
          hovertemplate: `%{y:.3f}<extra></extra>`
        }));
  
        const yAxisTitle = LIBERATED_GAS_Y_AXIS_TITLE;
  
        const layout = {
         
          xaxis: {
            title: {
              text: "Pressure (psia)",
              standoff: 10,
            },
            gridcolor: chartGridColor(this.isDarkMode),
          },
          yaxis: buildSimpleScatterLogYAxisConfig(axisType, {
            title: yAxisTitle,
            gridcolor: chartGridColor(this.isDarkMode),
            yValues: collectPositiveYValuesFromSeries(traces),
          }),
        margin: {
          l: 50,
          r: 0,
          b: 120
        },
          legend: { x: 0.95, y: 0, orientation: "v" },
        };

        const config = {
          responsive: true,
          displaylogo: false,
          displayModeBar: true,
          modeBarButtonsToRemove: ['lasso2d', 'select2d', 'pan2d', "resetscale","zoom", "toImage"],
          modeBarButtonsToAdd: [
              {
              name: "Expand",
              icon: {
                svg: `
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <image href="${Expand}" width="24" height="24"/>
                  </svg>
                `,
              },
              click: this.openModal,
            },
          {
            name: "Download CSV",
            icon: {
              svg: `
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <image href="${downloadIcon}" width="24" height="24"/>
                </svg>
              `,
            },
            click: this.handleDownloadCSV,
          },
          {
            name: "Download plot as a png",
            icon: {
              svg: `
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <image href="${camIcon}" width="24" height="24"/>
                </svg>
              `,
            },
            click: this.handleDownloadPNG,
          },
          ]
        };
  
        Plotly.newPlot(this.$refs[this.chartId], traces, layout, config);
      },
  
      plotModalChart() {
        const axisType = this.modalYAxisScale || "linear";
        const traces = this.chartData.map((series) => ({
          x: series.x,
          y: series.y.map((value) => {
            const numericValue = Number(value);
            if (!Number.isFinite(numericValue)) {
              return null;
            }
            if (axisType === "log" && numericValue <= 0) {
              return null;
            }
            return numericValue;
          }),
          type: "scatter",
          mode: "lines+markers",
          name: series.name,
          connectgaps: false,
          hovertemplate: `%{y:.3f}<extra></extra>`
        }));
  
        const yAxisTitle = LIBERATED_GAS_Y_AXIS_TITLE;
  
        const layout = {
          xaxis: {
            title: {
              text: "Pressure (psia)",
              standoff: 10,
            },
            gridcolor: chartGridColor(this.isDarkMode),
          },
          yaxis: buildSimpleScatterLogYAxisConfig(axisType, {
            title: yAxisTitle,
            gridcolor: chartGridColor(this.isDarkMode),
            yValues: collectPositiveYValuesFromSeries(traces),
          }),
           margin: {
          l: 50,
          r: 0,
          b: 120
        },
          legend: { x: 1.01, y: 0.035, orientation: "v" },
        };

        const config = {
          responsive: true,
          displaylogo: false,
          modeBarButtonsToRemove: ['lasso2d', 'select2d', 'pan2d', "resetscale","zoom", "toImage"],
          modeBarButtonsToAdd: [
              {
              name: "Expand",
              icon: {
                svg: `
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <image href="${Expand}" width="24" height="24"/>
                  </svg>
                `,
              },
              click: this.openModal,
            },
          {
            name: "Download CSV",
            icon: {
              svg: `
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <image href="${downloadIcon}" width="24" height="24"/>
                </svg>
              `,
            },
            click: this.handleDownloadCSV,
          },
          {
            name: "Download plot as a png",
            icon: {
              svg: `
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <image href="${camIcon}" width="24" height="24"/>
                </svg>
              `,
            },
            click: this.handleDownloadPNG,
          },
          ]
        };

        Plotly.Plots.resize(this.$refs[this.modalChartId])
        Plotly.newPlot(this.$refs[this.modalChartId], traces, layout, config);
      },
  
  
      openModal() {
        this.modal = true;
        this.$nextTick(() => {
          this.plotModalChart();
        });
      },
  
      closeModal() {
        this.modal = false;
      },

      handleDownloadCSV() {
      this.downloadChartCSV();
    },

    handleDownloadPNG() {
      this.downloadChartPNG();
    },

    downloadChartPNG() {
      const chartElement = this.$refs[this.chartId];
      if (!chartElement) return;
      downloadPlotlyHostAsPng(chartElement, this.chartTitle || "chart", {
        isDarkMode: this.isDarkMode,
      });
    },

    downloadChartCSV() {
      const csvHeader = [`Pressure (psia),${VAPOR_COMPONENT_MOLE_CSV_HEADER}\n`];

      const csvRows = this.chartData.map((series) =>
        series.x.map((x, index) => `${x},${series.y[index] ?? ""}`).join("\n")
      );

      const csvContent = csvHeader + csvRows.join("\n");

      const blob = new Blob([csvContent], { type: "text/csv" });

      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "chart-data.csv";

      a.click();

      URL.revokeObjectURL(url);
    }
    },
  };
  </script>